module.exports = require("plugin-pressuretests/shared/components/PressureTestAnnotation");